<script setup lang="ts"></script>

<template>
  <div :class="$style.root">{{ $t`Loading…` }}</div>
</template>

<style lang="scss" module>
.root {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  text-align: center;
}
</style>
